//top Navigation

(function($) {
    $.fn.menumaker = function(options) {
        var cssmenu = $(this),
            settings = $.extend({
                format: "dropdown",
                sticky: false
            }, options);
        return this.each(function() {
            $(this).find(".menu_button").on('click', function() {

                var mainmenu = $(this).next('ul');
                if (mainmenu.hasClass('open')) {
                    $('.menu_button').removeClass('menu-opened');
                    $(".menu_backdrop").hide();
                    $(".menu_ul").slideDown('slow');

                } else {
                    $('.menu_button').addClass('menu-opened');
                    $(".menu_backdrop").show();
                    $(".menu_ul").slideDown();
                }
            });
            $(".menu_backdrop").click(function() {

                $('.menu_button').removeClass('menu-opened');
                $(".menu_backdrop").hide();
                $(".menu_ul").slideUp('slow');
                $('.has-sub ul').removeClass('open');
                $('.has-sub ul').hide();
                $('.submenu-button, .show_dropdown, .has-sub ul').removeClass('submenu-opened');
                $(".button-menu-mobile").show();
            });
            cssmenu.find('li ul').parent().addClass('has-sub');
            multiTg = function() {
                cssmenu.find(".has-sub").prepend('<span class="submenu-button"></span>');
                cssmenu.find('.show_dropdown,.submenu-button').on('click', function() {

                    if ($(this).siblings('ul').hasClass('open')) {
                        $(this).siblings('ul').removeClass('open').slideToggle();
                        $(this).parent().children().removeClass('submenu-opened');
                    } else {
                        $(this).siblings('ul').addClass('open').slideToggle();
                        $(this).parent().children().addClass('submenu-opened');
                    }
                });
            };
            if (settings.format === 'multitoggle') multiTg();
            else cssmenu.addClass('dropdown');
            if (settings.sticky === true) cssmenu.css('position', 'fixed');
            resizeFix = function() {

                var mediasize = 1199;
                if ($(window).width() > mediasize) {

                    cssmenu.find('ul').show();
                    $('.menu_button').addClass('menu-opened');
                    $(".menu_backdrop").show()
                        // $('body').removeClass('left-side-menu-condensed');

                }
                if ($(window).width() <= mediasize) {

                    cssmenu.find('ul').hide().removeClass('open');
                    $('.menu_button').removeClass('menu-opened');
                    $(".menu_backdrop").hide()
                    $(this).siblings('ul').removeClass('open');
                    $('.submenu-button').removeClass('submenu-opened');
                    $(".button-menu-mobile").show();
                    $('body').addClass('left-side-menu-condensed');
                    $('body').removeClass('sidebar-enable ');

                }
            };
            resizeFix();
            return $(window).on('resize', resizeFix);
        });
    };
})(jQuery);

(function($) {
    $(document).ready(function() {

        $("#cssmenu").menumaker({
            format: "multitoggle"
        });
    });
})(jQuery);

//aside left menu
$(".aside_backdrop").click(function() {

    $('body').addClass('left-side-menu-condensed');
    $('body').removeClass('sidebar-enable ');
});

//scroll to section

if ($(window).width() < 1200) {
    $(".scroll_down").on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: ($(target).offset().top - 120)
        }, 500);
        $("body").removeClass("right-bar-enabled");
    });
} else {
    document.querySelectorAll('.scroll_down').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
            $("body").removeClass("right-bar-enabled");
        });

    });
}